import { Solution } from "@/services/solutions/types";
import { RecurenceEnum } from "@/services/posts/types";

export interface PowerPlan
{
    id: string;
    name: string;
    numberOfSolutions: number;
}

export interface PowerPlanEvent{
    id: string;
    name: string;
    powerPlanId: string;
    type: PowerPlanEventType | null,
    fromDate: string;
    toDate: string;
    fromTime: string;
    toTime: string;
    allDay: boolean;
    neverending: boolean;
    recurenceType: RecurenceEnum;
    recurenceValues: Array<number>;
    yearly: string;
}

export interface PowerPlanDetails{
    id: string;
    name: string;
    solutions: Solution[];
    events: PowerPlanEvent[];
}

export interface PowerPlanEventFilter{
    powerPlanId: string;
    calendarDate: string;
}

export interface ActiveDaysRequest {
    powerPlanId: string;
    calendarStartDate: Date;
}

export enum PowerPlanEventType{
    On,
    ForceOff,
    MaintenanceTime
}

export interface SolutionsUsingPowerPlan{
    solutionId: string,
    solutionName: string,
    userHasAccessToSolution: boolean
}
